import {
  Dialog,
  DialogTrigger,
  DialogClose,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from "@/components/ui/dialog";
import Callout from "@/sprout/callout";
import { Stack } from "@/sprout/layout";
import { Body } from "@/sprout/typography";
import { useTranslation } from "react-i18next";
import { PrimaryButton, TertiaryButton } from "@sprout/buttons";

type Props = {
  secondaryLink?: boolean;
};

const DreamJobInfoModal = ({ secondaryLink = false }: Props) => {
  const { t } = useTranslation("applications", { keyPrefix: "dream_job_info_modal" });

  return (
    <Dialog>
      <DialogTrigger>
        <TertiaryButton secondary={secondaryLink}>{t("button")}</TertiaryButton>
      </DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>
            <div>{t("title")}</div>
          </DialogTitle>
        </DialogHeader>
        <DialogDescription>
          <Stack gap="16px">
            <Body>{t("description")}</Body>
            <Callout showIcon={true} bodyText={t("callout")} />
          </Stack>
        </DialogDescription>
        <DialogFooter>
          <DialogClose>
            <PrimaryButton>{t("confirm")}</PrimaryButton>
          </DialogClose>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default DreamJobInfoModal;
